import ListItem from '@ixigo/iui/ListItem';
import ListItemIcon from '@ixigo/iui/ListItemIcon';
import ListItemText from '@ixigo/iui/ListItemText';
import Radio from '@ixigo/iui/Radio';
import type { CancellationReason } from '../../-api/cancellation';

export interface ReasonItemProps {
	reason: CancellationReason;
	selected: boolean;
	onClick: (reason: CancellationReason) => void;
}

export const ReasonItem = ({ reason, selected, onClick }: ReasonItemProps) => {
	return (
		<ListItem
			disablePadding
			className="py-10 hover:bg-transparent"
			onClick={() => onClick(reason)}
		>
			<ListItemIcon type="icon" className="w-6">
				<Radio
					value={reason.id}
					checked={selected}
					onChange={(e) => {
						e.stopPropagation();
						onClick(reason);
					}}
				/>
			</ListItemIcon>
			<ListItemText primary={reason.label} />
		</ListItem>
	);
};
